<script setup lang="ts">
import { ComboboxEmpty } from 'radix-vue';
import { type HTMLAttributes } from 'vue';

import { cn } from '@/components/lib/shadcn-vue/utils';

import type { ComboboxEmptyProps } from 'radix-vue';

const props = defineProps<ComboboxEmptyProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = computed(() => {
  const { ...delegated } = props;

  return delegated;
});
</script>

<template>
  <ComboboxEmpty v-bind="delegatedProps" :class="cn('py-6 text-center text-sm', props.class)">
    <slot />
  </ComboboxEmpty>
</template>
